import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';
const variantsCount = 6;

export default class TrainPanel extends Component {
	constructor(props) {
	    super(props);

		// Клонуємо масив фраз і фільтруємо.
		this.phrasesQueue =
				CommonFunctions.filterPhrases(this.props.app.phrases.slice())
				.filter(v => !this.props.app.unselectedPhrases.includes(v[0]));

 		this.variants = this.phrasesQueue.map(v => v[0]);

		// Скільки відповідей та пропусків.
		this.props.app.answersCount = 0;

		// Скільки правильних відповідей.
		this.props.app.rightAnswers = 0;

		// Скільки всього запитань.
		this.props.app.questionsCount = this.phrasesQueue.length;

		this.state = this.getNextState();
		this.onVariantClick = this.onVariantClick.bind(this);
		this.onSkipClick = this.onSkipClick.bind(this);
		this.finishTrain = this.finishTrain.bind(this);
	}

	playSentence(s) {
		CommonFunctions.speak(s);
	}

	getNextState() {
		let randomIndex = Math.trunc(Math.random() * this.phrasesQueue.length);

		let r = {
			hightlightRightVariant: false,
			phrase: this.phrasesQueue[randomIndex], // Правильна фраза та переклад.
			variants: [] };

		this.phrasesQueue.splice(randomIndex, 1);

		for (let i = 0; i < variantsCount; i++) r.variants.push('');

		// Робимо один з варіантів вірним.
		r.variants[ Math.trunc(Math.random() * variantsCount) ] = r.phrase[0];

		// Знаходимо випакові фрази для інших варіантів.
		for (let i = 0; i < variantsCount; i++) {
			if (r.variants[i] !== '') continue;
			let s;
			do {
				s = this.variants[
					Math.trunc(Math.random() * this.variants.length)];
			} while (r.variants.includes(s));
			r.variants[i] = s;
		}

		this.playSentence(r.phrase[0]);
		return r;
	 } // getNextState

	goToNextState() {
		if (this.phrasesQueue.length)
			this.setState(this.getNextState());
		else {
			this.props.app.wasTrainCompleted = true;
			this.props.app.setState({mode: 'trainResult'});
		}
	}

	onKeyDown(key) {
		if (key === 'f') this.finishTrain();
		else if (key === 'p')
			this.playSentence(this.state.phrase[0]);
		else if (['1', '2', '3', '4', '5', '6'].includes(key))
			this.onVariantSelect(this.state.variants[6 - parseInt(key, 10)]);
	}

	onVariantSelect(phrase) {
		if (this.state.hightlightRightVariant) return;
		this.props.app.answersCount++;

		if (phrase === this.state.phrase[0]) { // If the answer is right.
			this.props.app.rightAnswers++;
			this.setState({hightlightRightVariant: true});
			setTimeout(() => { this.goToNextState(); }, 900);
		} else
			this.goToNextState();
	} // onVariantSelect

	onVariantClick(e) {
		this.onVariantSelect(e.target.innerText);
	}

	onSkipClick() {
		if (!this.state.hightlightRightVariant) {
			this.props.app.answersCount++;
			this.goToNextState();
		}
	}

	finishTrain() {
		if (this.props.app.answersCount) {
			this.props.app.wasTrainCompleted = false;
			this.props.app.setState({mode: 'trainResult'});
		} else
			this.props.app.setState({mode: 'mainPanel'});
	}

	render() {
		const variantDivs = this.state.variants.map((v, i) => {

			let buttonStyle = {
				marginLeft: 8,
				paddingTop: 4,
				paddingBottom: 4,
				width: '96%'
			};

			if (this.state.hightlightRightVariant && this.state.phrase[0] === v)
				buttonStyle.backgroundColor = 'lightgreen';

			return (
				<div key={i} style={{width: '100%'}}>
					<span style={{color: 'gray'}}>{variantsCount - i}</span>
					<button
						style={buttonStyle}
						onClick={this.onVariantClick}>{v}</button>
				</div>
			);
		});

		const app = this.props.app;
		return (
			<div>

				<div style={{fontSize: 'small',
							 textAlign: 'right',
							 marginRight: 10}}>
					{app.answersCount + 1} / {app.questionsCount}
				</div>

				<div style={{fontSize: 'x-large',
							 color: 'green',
							 height:'100px',
							 lineHeight:'100px'}}>
					<span style={{display: 'inline-block',
  								  verticalAlign: 'middle',
								  lineHeight: 'normal'}}>
						{
							this.state.hightlightRightVariant
							?
							this.state.phrase[1]
							:
							(
								<img src='play-button.png'
									 alt='Play'
									 onClick={() => {
										this.playSentence(this.state.phrase[0]);
									 }} />
							)
						}
					</span>
				</div>

				{variantDivs}

				<div style={{marginTop: 5,
					         textAlign: 'right',
							 width: '90%'}}>
					<button onClick={this.onSkipClick}>Skip</button>
					<button onClick={this.finishTrain}>Finish</button>
				</div>

			</div> );
	} // render
} // class TrainPanel



// WEBPACK FOOTER //
// ./src/TrainPanel.js